import { render } from "./CheckButton.vue?vue&type=template&id=52fb86e8&scoped=true"
import script from "./CheckButton.vue?vue&type=script&lang=js"
export * from "./CheckButton.vue?vue&type=script&lang=js"

import "./CheckButton.vue?vue&type=style&index=0&id=52fb86e8&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fb86e8"]])

export default __exports__